/**
 * File: useMenuItemsQueries.ts
 * Path: apps/admin/src/modules/layout/hooks/useMenuItemsQueries.ts
 * Description: The menu items the signed-in role sees, for the sidebar, the
 * phone bar and the section pages. Accounting > Setup drops out once every
 * books setup step is done.
 */

import { useMemo } from "react";
import { useRole } from "@/modules/auth/hooks/useRoleQueries";
import { useBooksSetupDone } from "@/features/accounting/hooks/useBooksSetupDoneQueries";
import { menuItemsFor } from "../utils/menuItemsUtils";

export const useMenuItems = () => {
  const { can } = useRole();
  const setupDone = useBooksSetupDone(can("finance"));
  return useMemo(() => menuItemsFor(can, setupDone), [can, setupDone]);
};
